export default "<p>refer-afriend works!</p>\n"